// extracted by mini-css-extract-plugin
module.exports = {"macroVarselboks":"MacroVarselBoksDeprecated_macroVarselboks__WApp1"};